import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
    image: {
        backgroundColor: '#E0E0E0',
    },
    placeholder: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    placeholderText: {
        color: '#FFFFFF',
        fontWeight: '600',
    },
});
